var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75089 1.47529C10.0821 1.14407 10.0815 0.606475 9.75189 0.276843L9.72316 0.248106C9.39249 -0.0825596 8.857 -0.0831794 8.52471 0.249111L5.15665 3.61717C5.07013 3.70368 4.92841 3.70223 4.84335 3.61717L1.47529 0.249111C1.14407 -0.0821097 0.606475 -0.0815261 0.276843 0.248106L0.248106 0.276843C-0.0825596 0.607508 -0.0831794 1.143 0.249111 1.47529L3.61717 4.84335C3.70368 4.92987 3.70223 5.07159 3.61717 5.15665L0.249111 8.52471C-0.0821097 8.85593 -0.0815261 9.39353 0.248106 9.72316L0.276843 9.75189C0.607508 10.0826 1.143 10.0832 1.47529 9.75089L4.84335 6.38283C4.92987 6.29632 5.07159 6.29777 5.15665 6.38283L8.52471 9.75089C8.85593 10.0821 9.39353 10.0815 9.72316 9.75189L9.75189 9.72316C10.0826 9.39249 10.0832 8.857 9.75089 8.52471L6.38283 5.15665C6.29632 5.07013 6.29777 4.92841 6.38283 4.84335L9.75089 1.47529Z",
    fill: "#B6B6B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseGray);
export default __webpack_public_path__ + "static/media/icon_closeGray.52656a236a49ff63bfe3b2c14e3ae4c7.svg";
export { ForwardRef as ReactComponent };